import { render, staticRenderFns } from "./RoomOrderMeeting.vue?vue&type=template&id=a063f4ea"
import script from "./RoomOrderMeeting.vue?vue&type=script&lang=js"
export * from "./RoomOrderMeeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports